import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=02716c8c&scoped=true&"
import script from "./Photo.vue?vue&type=script&lang=ts&"
export * from "./Photo.vue?vue&type=script&lang=ts&"
import style0 from "./Photo.vue?vue&type=style&index=0&id=02716c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02716c8c",
  null
  
)

export default component.exports